import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  namespaced: true,
  actions: {},
  mutations: {
		setWidth(state, value){
			state.clientWidth = value
		},
  },
  state: {
		clientWidth:3,
  },
});

